export default __webpack_public_path__ + "static/media/SulphurPoint-Regular.1aab422e.woff";